import { render, staticRenderFns } from "./DropProjectTree.vue?vue&type=template&id=00013b52&scoped=true&"
import script from "./DropProjectTree.vue?vue&type=script&lang=js&"
export * from "./DropProjectTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00013b52",
  null
  
)

export default component.exports